export default {
  cocinasArray : []
}